import loadable from "@loadable/component";

/**
 * @namespace Retina
 */
export default loadable(() => import(/* webpackChunkName: "retinaLoadable.m" */ "./Initialize"));

